import { useQuery } from "@tanstack/react-query";
import { subventionService } from "@/features/subventions/services/subvention.service";

const SUBSIDY_SUMUPS_QUERY_KEY = ["subsidy-sumups"] as const;

export const useSubsidySumups = () => {
  return useQuery({
    queryKey: SUBSIDY_SUMUPS_QUERY_KEY,
    queryFn: subventionService.getSubsidySumups,
  });
};
